import React from "react";
import { Helmet } from "react-helmet";
import ResponsiveTopNavigation from "../../components/navigation/ResponsiveTopNavigation";
import Footer from "../../components/Footer";

const PrivacyPolicyPage = () => {

  const sectionTitle = (text) => (
    <h2 className="text-primary font-bold text-lg md:text-xl mb-2 font-[cairo]">{text}</h2>
  );

  const sectionText = (text) => (
    <p className="text-gray-800 text-sm md:text-base leading-relaxed whitespace-pre-line">
      {text}
    </p>
  );

  return (
    <>
      <Helmet>
        <title>سياسة الخصوصية</title>
      </Helmet>

      <ResponsiveTopNavigation />

      <main className="min-h-screen mt-16 bg-white px-4 md:px-8 py-6 md:py-8 mb-18 font-[cairo]">
        <div className="max-w-3xl mx-auto space-y-6">

          <div>
            {sectionTitle("تطبيق يسلمو - حماية بياناتك الشخصية")}
            {sectionText(
              "نحن ملتزمون بحماية خصوصيتك وبياناتك الشخصية. هذه السياسة توضح كيفية جمع واستخدام وحماية معلوماتك."
            )}
          </div>

          <div>
            {sectionTitle("جمع المعلومات")}
            {sectionText(
              "• المعلومات الشخصية:\n" +
              "نجمع المعلومات التي تقدمها لنا عند التسجيل أو استخدام التطبيق مثل الاسم، البريد الإلكتروني، رقم الهاتف، والعنوان.\n\n" +
              "• معلومات الموقع:\n" +
              "قد نجمع موقعك الجغرافي لتقديم خدمات التوصيل بشكل أفضل.\n\n" +
              "• معلومات الاستخدام:\n" +
              "نجمع بيانات عن استخدامك للتطبيق لتحسين تجربتك."
            )}
          </div>

          <div>
            {sectionTitle("استخدام المعلومات")}
            {sectionText(
              "• تقديم الخدمات:\n" +
              "نستخدم معلوماتك لمعالجة الطلبات وتقديم خدمات التوصيل.\n\n" +
              "• تحسين الخدمة:\n" +
              "نحسن جودة الخدمة وتجربة المستخدم.\n\n" +
              "• التواصل:\n" +
              "للتواصل معك بخصوص الطلبات أو التحديثات.\n\n" +
              "• الأمان:\n" +
              "لحماية حسابك ومنع الاحتيال."
            )}
          </div>

          <div>
            {sectionTitle("حماية البيانات")}
            {sectionText(
              "• التشفير:\n" +
              "نستخدم تقنيات تشفير لحماية بياناتك.\n\n" +
              "• الوصول المحدود:\n" +
              "الوصول للبيانات مقتصر على الموظفين المصرح لهم فقط.\n\n" +
              "• التدابير الأمنية:\n" +
              "نطبق إجراءات لحماية البيانات من الوصول غير المصرح به."
            )}
          </div>

          <div>
            {sectionTitle("مشاركة المعلومات")}
            {sectionText(
              "• مقدمي الخدمة:\n" +
              "قد نشارك البيانات مع المطاعم أو المتاجر لإتمام الطلب.\n\n" +
              "• الامتثال القانوني:\n" +
              "قد نكشف البيانات إذا طُلب ذلك قانونياً.\n\n" +
              "• عدم البيع:\n" +
              "لا نقوم ببيع بياناتك لأي طرف ثالث."
            )}
          </div>

          <div>
            {sectionTitle("حقوقك")}
            {sectionText(
              "• الوصول:\n" +
              "يمكنك الوصول إلى بياناتك وتحديثها.\n\n" +
              "• الحذف:\n" +
              "يمكنك طلب حذف حسابك.\n\n" +
              "• الاعتراض:\n" +
              "يمكنك الاعتراض على معالجة بياناتك في بعض الحالات."
            )}
          </div>

          <div>
            {sectionTitle("ملفات تعريف الارتباط (Cookies)")}
            {sectionText(
              "• الاستخدام:\n" +
              "نستخدم الكوكيز لتحسين تجربتك.\n\n" +
              "• التحكم:\n" +
              "يمكنك التحكم بها من خلال إعدادات المتصفح."
            )}
          </div>

          <div>
            {sectionTitle("التغييرات على السياسة")}
            {sectionText(
              "• التحديثات:\n" +
              "قد نقوم بتحديث السياسة من وقت لآخر.\n\n" +
              "• المراجعة:\n" +
              "ننصح بمراجعتها بشكل دوري."
            )}
          </div>

          <div>
            {sectionTitle("اتصل بنا")}
            {sectionText(
              "إذا كان لديك أي استفسار، يمكنك التواصل مع فريق دعم العملاء."
            )}
          </div>

        </div>
      </main>
      {/* <Footer/> */}
    </>
  );
};

export default PrivacyPolicyPage;